import { createStore, createEvent } from "effector"
import { IAssetSidebarProps } from "components/AssetSidebar/AssetSidebar"

const show = createEvent<IAssetSidebarProps>()
const hide = createEvent<IAssetSidebarProps>()
const clear = createEvent()

const list = createStore<IAssetSidebarProps[]>([])

list.on(show,
    (state: IAssetSidebarProps[], props: IAssetSidebarProps) => {
        return [...state, props]
    }
)

list.on(hide,
    (state: IAssetSidebarProps[], props: IAssetSidebarProps) => {
        return state.filter(p => p !== props)
    }
)

list.on(clear,
    () => []
)

export default {
    show,
    hide,
    clear,
    list,
}
